module.exports = __webpack_public_path__ + "static/media/assassin2.d763afcd.png";